
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.323 2.63L.75.168h17.357L13.914 7.22l-.001.002 3.145 4.592-1.51 2.52-3.146-4.759-2.912 4.759-6.177-9.351h6.406l-1.28 2.24h-.816l1.864 2.352 4.019-6.944H2.323zM21.113.168l-4.194 7.055 1.515 2.24 5.65-9.295h-2.971z","fill":"#fff"}})])
          )
        }
      }
    